import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2bbac88f&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2bbac88f', component.options)
    } else {
      api.reload('2bbac88f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2bbac88f&", function () {
      api.rerender('2bbac88f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Peajes/Mapa/index.vue"
export default component.exports